/**
 * @type {{ translation: ITranslationObject }}
 */
const ptBR = {
  translation: {
    FIELDS: {
      REQUIRED: 'campo obrigatório',
      REQUIRED_EMPTY: 'Campo obrigatório não preenchido',
      INVALID_INPUT: 'O valor digitado é inválido',
      WITHOUT_MASK: 'Sem máscara',
      PHONE_TYPE_COMERCIAL: 'Comercial',
      PHONE_TYPE_CELLPHONE: 'Celular',
      PHONE_TYPE_RESIDENTIAL: 'Residencial',
      PHONE_TYPE_FAX: 'Fax',
      PHONE_TYPE_OTHERS: 'Outros',
      INPUT_WITHOUT_OPTIONS: 'Não há opções referentes a sua pesquisa',
      FILE_MAX_SIZE_ALLOWED: 'Tamanho máximo permitido por arquivo: {{size}}',
      FILE_TOO_BIG_WARN: 'O arquivo {{item}} possui tamanho maior que {{size}}',
      CHOOSE_FILE: 'Escolher arquivo',
      MASK_ERROR : "Verifique se o campo foi preenchido de acordo com a máscara escolhida.",
      MASK_DROPDOWN: {
        MASK_IMG_BRA_ALT: 'Bandeira do Brasil',
        MASK_IMG_USA_ALT: 'Bandeira dos Estados Unidos',
        MASK_IMG_MEX_ALT: 'Bandeira do México',
        MASK_IMG_ARG_ALT: 'Bandeira da Argentina',
        MASK_IMG_CHL_ALT: 'Bandeira do Chile',
        MASK_IMG_URY_ALT: 'Bandeira do Uruguai',
        MASK_IMG_COL_ALT: 'Bandeira da Colômbia',
        MASK_IMG_PER_ALT: 'Bandeira do Peru',
        MASK_IMG_NONE_ALT: 'Sem bandeira',
      },
      
    },
    GENERICS: {
      TOASTER: {
        FORM_ERROR: 'Erro ao enviar o formulário',
        FORM_SUCCESS: 'Formulário enviado com sucesso'
      },
      LOADING: {
        SENDING_DATA: 'Enviando dados...',
        DONT_RELOAD_PAGE: 'Por favor, não recarregue a página até que a operação seja concluída.'
      },
      SENDING_FORM: 'Enviando formulário',
      EXTERNAL_FORM_TITLE: 'Formulário externo | Powered by Nagro',
      SEND: 'Enviar',
      HOUR: 'Hora',
      FORM_NOT_FOUND: 'Não foi possível localizar um formulário'
    }
  }
};

export default ptBR;